import { apiGateway } from '../api';

async function beneficiarioTitular(dadoBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiario/titular?numContrato=${numContrato}&chaveBusca=${dadoBusca.toString().trim()}`
        );
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function buscaBeneficiarioTrocarPlano(dadoBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(`/troca/plano?numContrato=${numContrato}&chaveBusca=${dadoBusca}`);
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function buscaBeneficiarioAlteracaoCadastral(dadoBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiario/alteracao/cadastral?numContrato=${numContrato}&chaveBusca=${dadoBusca}`
        );
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function buscaBeneficiarioDesligar(dadoBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiario/desligar?numContrato=${numContrato}&chaveBusca=${dadoBusca}`
        );
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function buscaBeneficiarioTransferencia(dadoBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiario/transferencia?numContrato=${numContrato}&chaveBusca=${dadoBusca}`
        );
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function buscaBeneficiarioTransferenciaFamilia(numeroAssociado = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiarios/carteiras/${numeroAssociado}/familia?numContrato=${numContrato}`
        );
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function validaCpfDuplicidade(body) {
    try {
        const response = await apiGateway.post(`/beneficiario/validar/cpf-duplicado/${body.cpf}`, body);
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function buscaBeneficiarioAposentadosdemitidos(dadosBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiario/aposentadosdemitidos?numContrato=${numContrato}&chaveBusca=${dadosBusca}`
        );
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function dadosBeneficiarioAposentadosdemitidos(numCarteirinha, numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiario/aposentadosdemitidos/${numCarteirinha}?numContrato=${numContrato}`
        );
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function buscaDados(dadoBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(`/beneficiario/dados?numContrato=${numContrato}&chaveBusca=${dadoBusca}`);
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

/**
 * buscaDadosV2 was created because we need to add "County Service and State Service"
 */
async function buscaDadosv2(dadoBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/portal/beneficiario/dados?numContrato=${numContrato}&chaveBusca=${dadoBusca}`
        );
        return response.data;
    } catch (error) {
        return false;
    }
}

async function buscaDadosDependente(numAssociado, numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiario/dados/${numAssociado}/dependente?numContrato=${numContrato}`
        );
        return response.data;
    } catch (error) {
        return false;
    }
}

async function buscaDadosPorContrato(numContrato) {
    try {
        const response = await apiGateway.get(
            `/TopdownContratoApi/contratos/numerocontrato/${numContrato}?situacaoContrato=Ativo`
        );
        return response.data;
    } catch (error) {
        return false;
    }
}

async function buscaBeneficiarioSegundaVia(dadoBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiarios/segunda-via?numContrato=${numContrato}&chaveBusca=${dadoBusca}`
        );
        return response.data;
    } catch (error) {
        // console.error(error);
        return false;
    }
}

async function buscaDependentes(numAssociado, numContrato = '') {
    try {
        const response = await apiGateway.get(`/beneficiarios/${numAssociado}/dependentes?numContrato=${numContrato}`);
        return response.data;
    } catch (error) {
        return false;
    }
}

async function tipoMovimentacao(numContrato = '') {
    try {
        const response = await apiGateway.get(`contrato/${numContrato}`);
        return response.data;
    } catch (error) {
        return false;
    }
}

async function buscaBeneficiarioReativar(dadosBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiarios/reativar?numContrato=${numContrato}&chaveBusca=${dadosBusca}`
        );
        return response.data;
    } catch (error) {
        return false;
    }
}

async function dadosBeneficiarioReativar(numAssociado, numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/beneficiarios/reativar/${numAssociado}/dados?numContrato=${numContrato}`
        );
        return response.data;
    } catch (error) {
        return false;
    }
}

async function cartaPermanencia(numAssociado) {
    try {
        const response = await apiGateway.get(
            `/api/TopDownBeneficiarioApi/api/v0/relatorios/declaracaopermanencia/numero/${numAssociado}?GerarArquivoBase64=true&GerarIdArquivo=false&GerarArquivoFileSystem=false`
        );
        return response.data;
    } catch (error) {
        return false;
    }
}

async function dadosBeneficiarioEventual(dadoBusca = '', numContrato = '') {
    try {
        const response = await apiGateway.get(
            `/api/TopDownBeneficiarioApi/api/v0/beneficiarios/numero-contrato/${numContrato}/chave-busca/${dadoBusca}`
        );
        return response.data;
    } catch (error) {
        return false;
    }
}

async function generatePDFCoop(body) {
    try {
        const response = await apiGateway.post('/financeiro/coparticipacao/emitir/gerar-pdf', body, {
            responseType: 'blob',
        });

        return response.data;
    } catch (error) {
        return error;
    }
}

async function buscaDadosConsultasFuturas(body) {
    try {
        const response = await apiGateway.post(`/agendamento-db/agp/tasy/consultas-futuras/pesquisar`, body);
        return response.data;
    } catch (error) {
        return false;
    }
}

async function buscaDadosConsultasRealizadas(body) {
    try {
        const response = await apiGateway.post(`/agendamento-db/agp/consultas-realizadas/pesquisar`, body);
        return response.data;
    } catch (error) {
        return false;
    }
}

async function gerarPdfAgendamento(body) {
    try {
        const response = await apiGateway.post('/agendamento-db/informacoes/busca-dados-pdf-sms', body);

        return response.data;
    } catch (error) {
        return [];
    }
}

export {
    beneficiarioTitular,
    buscaBeneficiarioTrocarPlano,
    buscaBeneficiarioAlteracaoCadastral,
    buscaBeneficiarioDesligar,
    buscaBeneficiarioTransferencia,
    buscaBeneficiarioTransferenciaFamilia,
    validaCpfDuplicidade,
    buscaBeneficiarioAposentadosdemitidos,
    dadosBeneficiarioAposentadosdemitidos,
    buscaDados,
    buscaDadosv2,
    buscaDadosDependente,
    buscaDadosPorContrato,
    buscaBeneficiarioSegundaVia,
    buscaDependentes,
    tipoMovimentacao,
    buscaBeneficiarioReativar,
    dadosBeneficiarioReativar,
    cartaPermanencia,
    generatePDFCoop,
    dadosBeneficiarioEventual,
    buscaDadosConsultasFuturas,
    buscaDadosConsultasRealizadas,
    gerarPdfAgendamento,
};
